import useGetApi from 'src/api/useGetApi';
import { FamousShipmentDTO } from './useFamousShipments';

const useFamousShipment = (shipmentId: string | null, enabled = true) => {
  return useGetApi<FamousShipmentDTO>({
    endpoint: `famous/shipments/${shipmentId}`,
    options: {
      enabled: enabled && !!shipmentId,
    },
  });
};

export default useFamousShipment;
